export default {
  webautoOneClickBuy: 'web-auto-one-click-buy',
  webauto: 'web-auto-m4u',
  dealers: 'dealers-digitais',
  dealersShinobi: 'dealers-digitais-shinobi',
  dealersEscale: 'dealers-digitais-escale',
  incentivoRecarga: 'incentivo-recarga',
  incentivoFluxoRecargas: 'incentivo-fluxo-recargas',
  callcenterInbound: 'callcenter-inbound',
  varejoWebM4u: 'm4u-varejo-web',
  whatsappEnd2End: 'whatsapp-e2e',
  whatsappHandover: 'whatsapp-ho',
  chatbotAura: 'chatbot-aura',
  portalVivo: 'portal-vivo',
  captivePreBemobi: 'captive-pre-bemobi',
  chatMovel: 'chat-movel',
  clmEmail: 'clm-email',
  clmSms: 'clm-sms',
  crossAec: 'cross-aec',
  crossAtento: 'cross-atento',
  emailPedidoCancelado: 'email-pedido-cancelado',
  outActionline: 'out-actionline',
  outAec: 'out-aec',
  outAtento: 'out-atento',
  outAtn: 'out-atn',
  outComunicar: 'out-comunicar',
  outParla: 'out-parla',
  outTel: 'out-tel',
  outTelecell: 'out-telecell',
  outTmkt: 'out-tmkt',
  outUranet: 'out-uranet',
  outVgx: 'out-vgx',
  segmentosSms: 'segmentos-sms',
  incentivoBemobi: 'incentivo-bemobi',
  carrinhoAbandonadoLoop: 'carrinho-abandonado-loop',
  carrinhoAbandonadoWebauto: 'carrinho-abandonado-webauto',
  captivePreBemobiNc: 'captive-pre-bemobi-nc',
  callCenterOutbound: 'callcenter-outbound',
  meuAppVivo: 'meu-app-vivo',
  captivePreBemobiNd: 'captive-pre-bemobi-nd',
  octbRcs: 'octb-rcs',
  octbRcsNovoCartao: 'octb-rcs-novo-cartao',
  octbRcsFallback: 'octb-rcs-fallback',
  appVivo: 'app-vivo',
  carrinhoAbandonadoVivoBr: 'carrinho_abandonado_vivo_br',
  ncPreVivoBr: 'nc_pre_vivo_br',
  recargaAppUpsellVivoBr: 'recarga-app-upsell-vivo-br',
  recargaWebUpsellVivoBr: 'recarga-web-upsell-vivo-br',
  appFbVivoBr: 'app-fb-vivo-br',
  transfligacaoVivoBr: 'transfligacao-vivo-br',
  varejoCommcenter: 'varejo-commcenter',
  incentivoSatPush: 'incentivo-sat-push',
  segmentosControlenLojaonline: 'segmentos-controlen-lojaonline',
  smsPre2cont: 'sms-pre2cont'
};
